/* HARMONY — Barra de anúncios
   Portado 1:1 do protótipo (harmonyfuture_1.html).
   Rotação automática, pausa no hover/foco, setas de controle manual,
   respeita prefers-reduced-motion. Reinicializa em cada carga de seção do
   Theme Editor (support a preview live no customizer). */
(function () {
  function initAnno(root) {
    var track = root.querySelector('#anno-track') || root.querySelector('.anno-track');
    if (!track) return;
    var msgs = Array.prototype.slice.call(track.querySelectorAll('.anno-msg'));
    if (msgs.length < 2) return;
    var idx = 0, timer = null, paused = false;
    var reduce = false;
    try { reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches; } catch (e) {}

    function show(i) {
      idx = (i + msgs.length) % msgs.length;
      msgs.forEach(function (m, k) { m.classList.toggle('on', k === idx); });
    }
    function next() { show(idx + 1); }
    function prev() { show(idx - 1); }
    function start() {
      if (reduce || timer) return;
      timer = setInterval(function () { if (!paused) next(); }, 6000);
    }
    function stop() {
      clearInterval(timer);
      timer = null;
    }

    var nextBtn = root.querySelector('.anno-next');
    var prevBtn = root.querySelector('.anno-prev');
    if (nextBtn) nextBtn.addEventListener('click', function () { next(); });
    if (prevBtn) prevBtn.addEventListener('click', function () { prev(); });

    root.addEventListener('mouseenter', function () { paused = true; });
    root.addEventListener('mouseleave', function () { paused = false; });
    root.addEventListener('focusin', function () { paused = true; });
    root.addEventListener('focusout', function () { paused = false; });

    show(0);
    start();

    // limpa o timer se a seção for removida/re-renderizada no editor de temas
    root._annoCleanup = stop;
  }

  document.addEventListener('DOMContentLoaded', function () {
    var bar = document.getElementById('anno');
    if (bar) initAnno(bar);
  });

  // Theme Editor: reinicia a rotação quando o comerciante edita a seção
  document.addEventListener('shopify:section:load', function (e) {
    var bar = e.target.querySelector ? e.target.querySelector('#anno') : null;
    if (bar) initAnno(bar);
  });
  document.addEventListener('shopify:section:unload', function (e) {
    var bar = e.target.querySelector ? e.target.querySelector('#anno') : null;
    if (bar && bar._annoCleanup) bar._annoCleanup();
  });
})();
